import axios from "axios";
import { getAccessToken } from "../../../shared/utils/axios";
import { type AssignmentScope, type SeedTrial } from "./seedAssignments";

export interface SeedAgOperationPayload {
  org_id: string;
  property_id: string;
  field_ids: string[];
  trial_types: string[];
}

export interface SeedAgOperationResponse {
  message: string;
}

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? "",
});

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === "string" && value.trim() !== "";

export const triggerSeedAgOperation = async (
  trial: SeedTrial,
  trialTypes: readonly string[],
  scope: AssignmentScope
): Promise<SeedAgOperationResponse> => {
  const orgId = trial.org_id;
  const propertyId = trial.property_id;
  const fieldIds = trial.field_ids;

  if (
    !isNonEmptyString(trial.id) ||
    !isNonEmptyString(orgId) ||
    !isNonEmptyString(propertyId) ||
    !Array.isArray(fieldIds) ||
    fieldIds.length === 0 ||
    !fieldIds.every(isNonEmptyString)
  ) {
    throw new Error(
      "The saved trial is missing its organization, property, or fields."
    );
  }

  if (trialTypes.length !== 1 || trialTypes[0] !== "seed") {
    throw new Error("The Seeds operation requires trial_types: ['seed'].");
  }

  const payload: SeedAgOperationPayload = {
    org_id: orgId,
    property_id: propertyId,
    field_ids: fieldIds,
    trial_types: ["seed"],
  };

  const response = await client.post<SeedAgOperationResponse>(
    `/trial/${encodeURIComponent(trial.id)}/ag_operation`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        "Cache-Control": "no-cache",
        "org-id": scope.orgId,
        "workspace-id": scope.workspaceId,
      },
    }
  );

  return response.data;
};
